import { useNavigate } from "react-router-dom";
import React from "react";
import { useTheme } from '@mui/material/styles';
import { useGlobalContext } from "../../context/globalContext";
import "./menuBar.css";
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

export default function MenuBar() {
    const theme = useTheme();
    const navigate = useNavigate();

    const {
        activeMenu,
        handleNavClick,
        isSidebarOpen,
        openSidebar,
        closeSidebar
    } = useGlobalContext();

    const handleClick = (destination) => {
        handleNavClick(destination);
        navigate("/" + destination);
    };

    return (
        <div>
            <nav className="navbar navbar-light navbar-expand-md justify-content-between">
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target=".dual-nav">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="navbar-collapse collapse dual-nav w-25 order-1 order-md-0">
                        <ul className="navbar-nav">
                            <li className="nav-item logo">
                                <img
                                    className="card-img-top menu-logo"
                                    src="/images/Original.png"
                                    alt="Achieversiq"
                                    onClick={() => handleClick("")}
                                    style={{ cursor: "pointer" }}
                                />
                            </li>
                        </ul>
                    </div>

                    {/* Navigation Links */}
                    <div className="navbar-collapse collapse dual-nav w-50 order-0 menu-nav justify-content-center">
                        <ul className="nav navbar-nav ml-auto">
                            <li className={`nav-item ${activeMenu === "" ? "active" : ""}`} onClick={() => handleClick("")}><a className="nav-link" href="#">Home</a></li>
                            <li className={`nav-item ${activeMenu === "all-courses" ? "active" : ""}`} onClick={() => handleClick("all-courses")}><a className="nav-link" href="#">Courses</a></li>
                            {/* <li className={`nav-item ${activeMenu === "materials" ? "active" : ""}`} onClick={() => handleClick("materials")}><a className="nav-link" href="#">Prep Materials</a></li>
                            <li className={`nav-item ${activeMenu === "study-abroad" ? "active" : ""}`} onClick={() => handleClick("study-abroad")}><a className="nav-link" href="#">Study Abroad</a></li> */}
                            <li className={`nav-item ${activeMenu === "blogs" ? "active" : ""}`} onClick={() => handleClick("blogs")}><a className="nav-link" href="#">Blogs</a></li>
                            <li className={`nav-item ${activeMenu === "help" ? "active" : ""}`} onClick={() => handleClick("help")}><a className="nav-link" href="#">Help</a></li>
                            <li className={`nav-item ${activeMenu === "about" ? "active" : ""}`} onClick={() => handleClick("about")}><a className="nav-link" href="#">About Us</a></li>
                        </ul>
                    </div>

                    {/* Login & Demo Button */}
                    <div className="navbar-brand d-block text-center order-2 order-md-1 mx-auto w-25">
                        <a href="https://login.achieversiq.com/" className="menu-login">Log In</a>
                        <button className="primary-button btn btn-primary mx-3 custom-shadow" onClick={() => handleClick("book-demo")} >
                            Request Demo <KeyboardArrowRightRoundedIcon />
                        </button>
                    </div>
                </div>
            </nav>
        </div>
    );
}
